import type { KyInstance } from 'ky';
import type {
  AutomationControlRequest,
  AutomationControlView,
  SetAutomationControlRequest,
} from './types/automationControl';

const path = (id: string) => `api/v1/messaging/conversations/${id}/automation-control`;
export function buildAutomationControlApi(http: KyInstance) {
  return {
    get: (id: string) => http.get(path(id)).json<AutomationControlView>(),
    set: (id: string, body: SetAutomationControlRequest) =>
      http.put(path(id), { json: body }).json<AutomationControlView>(),
    operate: (id: string, action: 'takeover' | 'resume', body: AutomationControlRequest) =>
      http.post(`${path(id)}/${action}`, { json: body }).json<AutomationControlView>(),
  };
}
